export const initInfo = {
  "resultCode":0,
  "resultMsg":"操作成功",
  "resultData":{
      "msg":"成功",
      "code":"00000hby",
      "data":{
          "result":"now",
          "beginTime":1544061600000,
          "endTime":1544095800000
      },
    "success":true
  }
}

// 非当前时间段进活动页（next距离开始：当前-beginTime）
// export const initInfo = {
//   "resultCode":0,
//   "resultMsg":"操作成功",
//   "resultData":{
//       "msg":"非当前时段",
//       "code":"10001hby",
//       "data":{
//           "result":"next",
//           "beginTime":1544166000000,
//           "endTime":1544184360000
//       },
//       "success":false
//   }
// }

// export const initInfo = {
//   "resultCode":-1,
//   "resultMsg":"您访问的该接口出现异常！Message:error:222_[JSF-22010]No alive provider! The key is jsf://com.jd.newGravity.gateway.INewGravityGateWay:newGravity_yf, current providers is [jsf://172.23.214.4:22066/?safVersion=210&jsfVersion=1651&interface=com.jd.newGravity.gateway.INewGravityGateWay&alias=newGravity_yf]",
//   "success":false
// }

// export const myShareInfo = {
//     "resultCode": 0,
//     "resultMsg": "操作成功",
//     "resultData": {
//      "msg": "成功",
//      "code": "00000hby",
//      "data": {
//       "myRewardList": [],
//       "joinUserNum": "19",
//       "ridingLantern": ["籍***p抢到测池3-话费充值", "吠***j抢到测池1-随机5", "E***f抢到测池3-闪付", "句***F抢到测池1-随机2", "熊***彭抢到测池3-借钱", "j***h抢到测池4-金币", "晨***u抢到测池1-随机3", "T***D抢到测池1-随机2", "O***T抢到测池1-随机3", "湃***I抢到测池1-随机2"],
//       "nextornow": {
//        "result": "now",
//        "beginTime": 1544749200000,
//        "endTime": 1544760000000,
//        "nextTime": 1544765400000
//       },
//       "isjoin": "0"
//      },
//      "success": true
//     }
//   }

  export const myShareInfo = {
    "resultCode":-1,
    "resultMsg":"您访问的该接口出现异常！Message:error:222_[JSF-22010]No alive provider! The key is jsf://com.jd.newGravity.gateway.INewGravityGateWay:newGravity_yf, current providers is [jsf://172.23.214.4:22066/?safVersion=210&jsfVersion=1651&interface=com.jd.newGravity.gateway.INewGravityGateWay&alias=newGravity_yf]",
    "success":false
  }

// export const takeReward1 = {
//     "resultCode": 0,
//     "resultMsg": "操作成功",
//     "resultData": {
//         "msg": "当前参与人数过多，请稍后再试",
//         "code": "10004zt",
//         "success": false
//     }
// }

export const takeReward1 = {
    "resultCode": 0,
    "resultMsg": "操作成功",
    "resultData": {
    "msg": "成功",
    "code": "00000hby",
    "data": {
    "reward": {
    "ext": "{\"create\":\"2018-12-14 17:07:55\"}",
    "buttonName": "新人按钮",
    "rewardType": 2,
    "actCode": "3F6F973E69",
    "rewardURL": "https://m.jr.jd.com/mjractivity/rn/coupon-rn/index.html?RN=coupon-rn&sid=",
    "rewardName": "测-新人",
    "rewardAmount": 1
    },
    "globalfight": "51.20%",
    "hbNum": 5,
    "nextornow": {
    "result": "now",
    "beginTime": 1544778000000,
    "endTime": 1544785200000,
    "nextTime": 1544787000000
    }
    },
    "success": true
    }
}

export const isShareRoleInfo = {
  "resultCode":0,
  "resultMsg":"操作成功",
  "resultData":{
    "msg":"新用户",
    "code":"00000hby",
    "success":true
  }
  // "resultData": {
  //   "code": "10005hby",
  //   "success": false,
  //   "msg": "非新用户"
  // }
}

// export const isShareRoleInfo = {
//     "resultCode":0,
//     "resultMsg":"操作成功",
//     "resultData":{
//         "msg": "当前参与人数过多，请稍后再试",
//         "code": "10004zt",
//         "success":true
//     }
//   }

export const addTimes = {
  "resultCode":0,
  "resultMsg":"操作成功",
  "resultData":{
      "msg":"成功",
      "code":"00000hby",
      "data":{
          "result":"now",
          "beginTime":1544166000000,
          "endTime":1544184360000
      },
      "success":true
  }
}

export const isFinishedInfo = {
  "resultCode":0,
  "resultMsg":"操作成功",
  "resultData":{
      "msg":"成功",
      "code":"00000hby",
      "data":{
          "tixing":"no",
          "weixin":"no"
      },
      "success":true
  }
}